<template>
    <!--<div>
        <div v-if="componentLoading">
            <p class="text-2xl text-orange-500 mt-6 ml-6">Loading...</p>
        </div>-->
        <div class="pb-20">


            <div v-if="!smartphone">

                <content-section v-if="contentCounts > 0" :sectiontitle_es="title_es" :sectiontitle_en="title_en" :filter="category_id" :currentlocale="currentlocale" contentCount="0" :default_thumbnail="default_thumbnail"></content-section>

                <div v-else class="p-8">
                    <h1 v-if="currentlocale==='es'" class="text-xl text-theme-title font-bold mt-8 mb-8 ml-6">Estamos preparando más Contenido para Usted.</h1>
                    <h1 v-else class="text-xl text-theme-title font-bold mt-8 mb-8 ml-6">We are preparing more content for you.</h1>
                    <p v-if="currentlocale==='es'" class="text-base text-theme-main ml-6">Tenemos mucho más que mostrarle, lo podrá encontrar en las otras secciones de nuestro portal.</p>
                    <p v-else class="text-base text-theme-main ml-6">We have much more to show you, you can find it by visiting other sections of our Portal.</p>
                </div>

            </div>



            <div v-if="smartphone">

                <mobile-content-section v-if="contentCounts > 0" :sectiontitle_es="title_es" :sectiontitle_en="title_en" :filter="category_id" :currentlocale="currentlocale" contentCount="0" :default_thumbnail="default_thumbnail"></mobile-content-section>

                <div v-else class="p-8">
                    <h1 v-if="currentlocale==='es'" class="text-xl text-theme-title font-bold mt-8 mb-8 ml-6">Estamos preparando más Contenido para Usted.</h1>
                    <h1 v-else class="text-xl text-theme-title font-bold mt-8 mb-8 ml-6">We are preparing more content for you.</h1>
                    <p v-if="currentlocale==='es'" class="text-base text-theme-main ml-6">Tenemos mucho más que mostrarle, lo podrá encontrar en las otras secciones de nuestro portal.</p>
                    <p v-else class="text-base text-theme-main ml-6">We have much more to show you, you can find it by visiting other sections of our Portal.</p>
                </div>


            </div>


        </div>
    <!--</div>-->
</template>

<script>

    import { isMobileOnly } from 'mobile-device-detect';
    import { isTablet } from 'mobile-device-detect';

    export default {

        /*computed: {
            thisDevice() {
                return deviceDetect()
            }
        },*/

        props: [
            'currentlocale',
            'category_id',
            'title_es',
            'title_en',
            'default_thumbnail'
        ],

        data() {
            return {
                /*componentLoading: true,*/
                smartphone: isMobileOnly,
                tabletDevice: isTablet,

                contentCounts: []
            }
        },

        methods: {

            getContentsCounts() {

                axios.get('/api/count/category/' + this.category_id  + '/content' + '/' + this.currentlocale)
                    .then(response => {
                        this.contentCounts = response.data;
                    })
                    .catch(error => {
                        this.componentLoading = false;
                        console.log('SERVER ERROR!! --> ' + JSON.stringify(error));
                    });

            }

        },

        mounted() {

            this.getContentsCounts();

        }
    }
</script>
